import {  SlotGameType1_3 } from "../SlotGameType1_3";
export class LuckyIce100_3 extends SlotGameType1_3{ }